import React, { useEffect, useState } from "react";
import { saveAs } from 'file-saver';
import { useSelector } from 'react-redux'
import { toBlob } from 'html-to-image';
import { Toast } from '../shared/Toast'
import { SlIcon } from "@shoelace-style/shoelace/dist/react";
import CreativeNameDisplay from "../shared/CreativeNameDisplay"
import detectLanguage from "./promotedPreviewStyles";
function PromotedImagePreview({ preview }) {
  const componentId = useSelector(state => state.Head.component_id)
  const [description, setDescription] = useState("");

  const handleClick = () => {
    let url = preview.button_link;
    if (!/^https?:\/\//i.test(url)) {
      url = `https://${url}`;
    }
    window.open(url, '_blank');
  };

  const handleClickUrl = () => {
    if (preview.click_url !== null && preview.click_url !== undefined && preview.click_url !== '') {
      let url = preview.click_url
      if (!/^https?:\/\//i.test(url)) {
        url = `https://${url}`;
      }
      window.open(url, '_blank');
    }
    else {
      Toast('error', "There is nothing to show")
    }
  }


  useEffect(() => {
    setDescription(prevDescription => {
      let newDescription = preview.description || "";
      if (newDescription?.search("<<>>") !== -1) {
        let text = newDescription.match(/<<-1>>[a-zA-Z0-9\u0C00-\u0C7F !@#$%^&*(),.?'":{}|]+<<>>/gm);
        let text_inside = newDescription.match(/<<-1>>[a-zA-Z0-9\u0C00-\u0C7F !@#$%^&*(),.?'":{}|]+<<>>/gm);
        text_inside = String(text_inside);
        text_inside = text_inside.substring(6, text_inside.length - 4);
        if (text?.length) {
          newDescription = newDescription.replace(/<<-1>>[a-zA-Z0-9\u0C00-\u0C7F !@#$%^&*(),.?'":{}|]+<<>>/gm, `<span  class="hover:cursor-pointer" style="color:blue; text-decoration:underline">${text_inside}</span>`);
        }
        let newtext = newDescription.match(/<<(((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)|(tel:\+91[6-9][0-9]{9}))>>[a-zA-Z0-9\u0C00-\u0C7F !-@#$%^&*(),.?'":{}|]+<<>>/gm);
        let linktext = newDescription.match(/>>[a-zA-Z0-9\u0C00-\u0C7F !-@#$%^&*(),.?'":{}|]+<<>>/gm);
        const originalString = String(linktext);
        const modifiedString = originalString.substring(2, originalString.length - 4);
        console.log(linktext, originalString, modifiedString, newtext)
        if (newtext?.length) {
          newDescription = newDescription.replace(/<<(((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)|(tel:\+91[6-9][0-9]{9}))>>[a-zA-Z0-9\u0C00-\u0C7F !-@#$%^&*(),.?'":{}|]+<<>>/gm, `<span  class="hover:cursor-pointer" style="color:blue; text-decoration:underline">${modifiedString}</span>`);
        }
        let phone_text = newDescription.match(
          /(?<=<<(0\d{10}|[6-9]\d{9})>>)[a-zA-Z0-9-!@#$ %^&*(),.?'":{}|]+(?=<<>>)/gi
        );
        if (phone_text) {
          for (let i of phone_text) {
            newDescription = newDescription.replace(
              /<<(0\d{10}|[6-9]\d{9})>>[a-zA-Z0-9-!@#$%^ &*(),.?'":{}|]+<<>>/i,
              `<span style="color:blue">${i}</span>`
            );
          }
        }
        let subText = newDescription.match(
          /(?<=<<12>>)[a-zA-Z0-9!@#$ %^&*(),.?'":{}|]+(?=<<>>)/gi
        );
        if (subText) {
          for (let i of subText) {
            newDescription = newDescription.replace(
              /<<(12)>>[a-zA-Z0-9!@#$%^ &*(),.?'":{}|]+<<>>/i,
              `<span style="color:blue">${i}</span>`
            );
          }
        }
      }
      return newDescription;
    });
    const handleClickOnSpan = (event) => {
      const target = event.target;
      if (target.tagName.toLowerCase() === "span" && target.classList.contains("hover:cursor-pointer")) {
        const url = preview.click_url;
        if (url) {
          handleClickUrl();
        }
      }
    };

    document.addEventListener("click", handleClickOnSpan);

    // Clean up the event listener when the component unmounts
    return () => {
      document.removeEventListener("click", handleClickOnSpan);
    };
  }, [preview.description]);

  const handleDownloadPreview = () => {
    const previewElement = document.querySelector('.download-preview');
    toBlob(previewElement).then(function (blob) {
      saveAs(blob, `${preview.name}.png`);
    });
  };


  const { heading, descrip } = detectLanguage(preview.head_line)
  return (
    <div>
      <div className="flex mb-5">

        {componentId === 6 ? <div className="justify-end">
          <sl-icon-button
            library="lucide"
            name="download"
            onClick={handleDownloadPreview}
          ></sl-icon-button>
        </div> : null}
      </div>
      <div className="download-preview">
        <CreativeNameDisplay preview={preview} />
        <div className="preview-inner">
          <div className="preview-promoted-image !h-[90%]">
            {preview.img_urls && <img src={preview.img_urls} alt="" className="w-full !h-[40%]" />}
            <div className="p-2">
              <h6 className="hover:cursor-pointer" style={heading} onClick={handleClickUrl}>{preview.head_line}</h6>
              <div dangerouslySetInnerHTML={{ __html: description }} style={descrip}></div>
              {preview.button_enabled !== 0 ? (
                preview.btn_text_bgclr !== "#ffffff" ? (
                  <div className="flex justify-center p-2">
                    <button className="btn" style={{ backgroundColor: preview.btn_text_bgclr, color: preview.btn_text_clr, border: `1px solid ${preview.btn_text_clr} ` }} onClick={handleClick}>{preview.button_text}</button>
                  </div>
                ) : (
                  <div className="flex justify-center p-2">
                    <button onClick={handleClick}>{preview.button_text}</button>
                  </div>
                )
              ) : null}
            </div>
          </div>
          <span className="text-xs mb-2 px-2 text-gray-400 flex items-center"><SlIcon library="lucide" name="megaphone"></SlIcon>&nbsp;Sponsored story</span>
          <hr className="!m-0"></hr>
        </div>
      </div>
    </div>
  );
}

export default PromotedImagePreview;
